import { Injectable } from "@angular/core";

@Injectable()
export class Constants {
  public readonly API_ENDPOINT: string =
    "https://investor-portal-mock-dev.ace-alternatives.com";
  public readonly API_MOCK_ENDPOINT: string =
    "https://investor-portal-mock-dev.ace-alternatives.com";
  public static TitleOfSite: string = "PC Portal";
}
